import { baseRouteCreator } from '@occc-app/routes/CampaignComponents/utils';
import { ConstraintFragment } from '@occc/graphql';
import { ChipList } from '@occc-app/routes/CampaignComponents/component-details/components';
import { getConstraintsByType } from '../constraints-section.utils';
import { ownershipConditionLabels } from '../constants';
import { ConstraintSupplementalData } from '../../../component-details.types';
import { formatValues } from '../../formatters';

export const PurchasableEligibilityConstraint = ({
  constraints,
  constraintSupplementalData,
}: {
  constraints: ConstraintFragment[];
  constraintSupplementalData?: ConstraintSupplementalData;
}) => {
  const cst = getConstraintsByType('ConstraintPurchasableEligibility', constraints);

  const campaignId = constraintSupplementalData?.campaignId ?? '';
  const offersMap = constraintSupplementalData?.ConstraintPurchasableEligibility;

  const linkItems = cst.flatMap((c) =>
    (c.voucheredOffers ?? []).map((voucheredOffer) => {
      const offer = offersMap?.[voucheredOffer.id];
      return {
        label: offer?.name ?? voucheredOffer.name,
        href: baseRouteCreator.details(campaignId, offer?.id ?? voucheredOffer.id),
      };
    }),
  );

  const ownershipConditionTitles = formatValues(
    cst.map((c) => ownershipConditionLabels[c.ownershipCondition]),
  );

  return (
    <ChipList label='Award Restriction' countPrefix={ownershipConditionTitles} items={linkItems} />
  );
};
